import { render, staticRenderFns } from "./TeamCarriersOverview.vue?vue&type=template&id=4bd40974&scoped=true&"
import script from "./TeamCarriersOverview.vue?vue&type=script&lang=js&"
export * from "./TeamCarriersOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamCarriersOverview.vue?vue&type=style&index=0&id=4bd40974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd40974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd40974')) {
      api.createRecord('4bd40974', component.options)
    } else {
      api.reload('4bd40974', component.options)
    }
    module.hot.accept("./TeamCarriersOverview.vue?vue&type=template&id=4bd40974&scoped=true&", function () {
      api.rerender('4bd40974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamCarriers/TeamCarriersOverview.vue"
export default component.exports